import restrictInput from './restrictInput';
// 统一注册 说明功能
const install = function (Vue) {
  // 限制input输入特殊字符，防止 sql 注入
  Vue.directive('restrict-input', restrictInput);
};
export default install;
